import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import logo from './rpl-logo.png';
import { showModal } from '../modal/actions';

import style from './style.pcss';

@connect(() => ({}), (dispatch) => ({
    dispatchShowModal: () => dispatch(showModal())
}))
class Header extends Component {

    static displayName = '[block] header';

    static propTypes = {
        dispatchShowModal: PropTypes.func
    };

    showHelp = (e) => {
        e.preventDefault();

        this.props.dispatchShowModal();
    };

    render() {
        return (
            <div className={style['header']}>
                <img src={logo} alt="logo" className={style['header__logo']} />
                <h2 className={style['header__h']}>Печать спортивной линии</h2>
                <button className={style['header__help']} onClick={this.showHelp} />
            </div>
        )
    }

}

export default Header;



// WEBPACK FOOTER //
// ./src/blocks/header/index.js